import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 18l6 -6l-6 -6v12","key":"svg-0"}]]

const IconCaretRight = createReactComponent('outline', 'caret-right', 'CaretRight', __iconNode);

export default IconCaretRight;